"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCHABLE_SELECT_PROPS = void 0;
// Add these props to an AntD <Select /> component so that search input will be compared
// against the option labels (instead of just their values).
var SEARCHABLE_SELECT_PROPS = {
  filterOption: function filterOption(input, option) {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  },
  optionFilterProp: 'children',
  showSearch: true
};
exports.SEARCHABLE_SELECT_PROPS = SEARCHABLE_SELECT_PROPS;